//Baee components
import Vue from 'vue';
import app from './app.vue';

//External modules
import VueRouter from 'vue-router';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueCookies from 'vue-cookies';
import FullCalendar from 'vue-full-calendar';
import moment from 'moment';
import VCalendar from 'v-calendar';

//Global internal modules
import environment from './components/common/environment.vue';
import navigation from './components/common/navigation.vue';
import alert from './components/common/alert.vue';
import foot from './components/common/foot.vue';

//Internal modules
import dateMain from './components/date.vue';
import receiptMain from './components/receipt.vue';
import donorMain from './components/donor.vue';
import ereceiptMain from './components/ereceipt.vue';

//CSS
import './assets/css/custom.scss';
import 'bootstrap';
import './assets/js/fontawesome.js';
import './assets/css/screen.css';
import './assets/css/webfonts.css';
import './assets/css/floating-labels.css';
import 'fullcalendar/dist/fullcalendar.min.css';

//jQuery
window.$ = window.jQuery = require('jquery');

Vue.component('alert', alert);
Vue.component('environment', environment);
Vue.component('foot', foot);

Vue.use(VueCookies);
Vue.use(VueAxios, axios);
Vue.use(FullCalendar);
Vue.use(VueRouter);
Vue.use(VCalendar);
Vue.use(moment);

const alertDefault = {
  display: false,
  message: '',
  class: 'alert-primary',
  timeout: false
};

const router = new VueRouter({
  mode: 'history',
  base: process.env.VUE_APP_BASE_SRC,
  routes: [
    { 
			name: 'date',
			path: '/date', 
			components: {
				default: dateMain,
				navigation: navigation
			},
			props: {
				default: true,
				navigation: true
			}
        },		
        { 
			name: 'receipt',
			path: '/receipt', 
			components: {
				default: receiptMain,
				navigation: navigation
			},
			props: {
				default: true,
				navigation: true
			}
        },		
        { 
			name: 'donor',
			path: '/donor', 
			components: {
				default: donorMain,
				navigation: navigation
			},
			props: {
				default: true,
				navigation: true
			}
		},		
		{ 
			name: 'ereceipt',
			path: '/ereceipt/:type?/:param?/:startDate?/:endDate?', 
			components: {
				default: ereceiptMain,
				navigation: navigation
			},
			props: {
				default: true,
				navigation: true
			}
		},
		{
			path: '*',
			redirect: '/ereceipt'
		}	
  ]
});

fetch(process.env.BASE_URL + "config.json")
  .then((response) => response.json())
  .then((config) => {
    Vue.prototype.$config = config;      
    new Vue({
      router,  
      data: function() {
        return {
            user: {},
            alert: JSON.parse(JSON.stringify(alertDefault)),
            dates: [],
            events: [],
            loggedIn: false,
            loading: false,
            config: {},
            source: this.$config[process.env.VUE_APP_ENV].app.queue_source,
            data: [{PROCESSED_DATE: ''}]
          };
        },
        created() {          
          this.isLoggedIn();          
        },
    
      methods: {
        isLoggedIn: function () {
          const t = window.location.pathname.substring(window.location.pathname.indexOf(this.$config[process.env.VUE_APP_ENV].app.base) + this.$config[process.env.VUE_APP_ENV].app.base.length, window.location.pathname.length);
          const c = this.$config.app_cookie;
          //this.$cookies.remove(c);
          const e = process.env.VUE_APP_ENV;
          if (this.$cookies.isKey(c)) {
            this.user = this.$cookies.get(c);        
            this.loggedIn = true;
          } else {
            let location = this.$config[process.env.VUE_APP_ENV].uri.data + '/secure/user.data.php?target=' + t;                       
            window.location = location;            
          }
        },
        receiptLookup: function() {
          var _this = this;
          this.loading = true;
          this.axios.get(this.$config[process.env.VUE_APP_ENV].app.base+'data/php/date/date.lookup.php').then(response => {		                                
            if (response.data.error) {
              _this.setAlert(true, response.data.error, 'alert-danger');
              _this.loading = false;
              return;
            }	
            this.data = response.data;			
            for (var i = 0; i < response.data.length; i++) {
              if (response.data[i].RECEIPTS > 0) {
                _this.events.push({
                  id: '0_receipts_'+i,
                  title: 'Receipts: '+response.data[i].RECEIPTS,
                  start: response.data[i].PROCESSED_DATE,
                  className: ['border-success', 'bg-success', 'text-white'],
                  data: {type: 'DAILY', date: response.data[i].PROCESSED_DATE}						
                })	
              }
              if (response.data[i].REVERSALS > 0) {
                _this.events.push({
                  id: '1_reversals_'+i,
                  title: 'Modifications: '+response.data[i].REVERSALS,
                  start: response.data[i].PROCESSED_DATE,
                  className: 'reversals',
                  className: ['border-primary', 'bg-primary', 'text-white'],
                  data: {type: 'REVERSAL', date: response.data[i].PROCESSED_DATE}				
                })	
              }
              if (response.data[i].SECURITIES > 0) {
                _this.events.push({
                  id: '2_securities_'+i,
                  title: 'Stock letters: '+response.data[i].SECURITIES,
                  start: response.data[i].PROCESSED_DATE,
                  className: ['border-danger', 'bg-danger', 'text-white'],
                  data: {type: 'STOCK', date: response.data[i].PROCESSED_DATE}				
                })	
              }
              if (response.data[i].IRA > 0) {
                _this.events.push({
                  id: '3_ira_'+i,
                  title: 'IRA letters: '+response.data[i].IRA,
                  start: response.data[i].PROCESSED_DATE,
                  className: ['border-warning', 'bg-warning'],
                  data: {type: 'IRA', date: response.data[i].PROCESSED_DATE}				
                })	
              }			
              if (response.data[i].DAF > 0) {
                _this.events.push({
                  id: '4_daf_'+i,
                  title: 'DAF letters: '+response.data[i].DAF,
                  start: response.data[i].PROCESSED_DATE,
                  className: ['border-secondary', 'bg-secondary', 'text-white'],
                  data: {type: 'DAF', date: response.data[i].PROCESSED_DATE}				
                })	
              }					
              if (response.data[i].ERECEIPT > 0) {
                _this.events.push({
                  id: '5_ereceipt_'+i,
                  title: 'E-receipts: '+response.data[i].ERECEIPT,
                  start: response.data[i].PROCESSED_DATE,
                  className: ['border-info', 'bg-info', 'text-white'],
                  data: {type: 'ERECEIPT', date: response.data[i].PROCESSED_DATE}				
                })	
              }	
            }											
            _this.loading = false;     
            }).catch(error => {
              _this.setAlert(true, error, 'alert-danger');
              _this.loading = false;
               return;
          });                        
        },      
        clearAlert: function () {
          this.alert = JSON.parse(JSON.stringify(alertDefault));
        },
        setAlert: function (display, message, css) {
          this.alert.display = display;
          this.alert.class = css;
          this.alert.message = message;
        },
      },
      computed: {
        transactionDateNice: function() {			
            var d = this.$route.params.txnDate;
            var out = moment(d, "YYYYMMDD").format("MMMM Do, YYYY");			
            return out;
        }
      },
      mounted() {
     
      },
      created() {		
        this.isLoggedIn();
        this.receiptLookup();
      },
      render: (h) => h(app)
    }).$mount('#app');
  });

  Vue.filter('highlight', function(item, query) {
    var invalid = /[°"§%()\[\]{}=\\?´`'#<>|,;.:+_]+/g;
    var repl = query.replace(invalid, "");
    var check = new RegExp(repl, "ig");
    return item.toString().replace(check, function(matchedText,a,b){
      return ('<span class="bg-warning text-white">' + matchedText + '</span>');
    });
  });
  
  Vue.filter('currency', function(value) {
    if (value == null) {
      return;
    }
    if (typeof value === 'string' || value instanceof String) {
      value = parseFloat(value);
    }
    return '$'+value.toFixed(2).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");	
  });
  
  Vue.directive('tooltip', function(el, binding){
      $(el).tooltip({
      title: binding.value,
          placement: binding.arg,
          trigger: 'hover'             
      });
  });